import axios from 'axios';
import { CODE_VERIFIER } from '../../utils/constants';
import { API } from '../../utils/api';

/**
 * @description
 * Exchanges the SSO authorization code for access/refresh tokens via location-service-api.
 * CRR client secret is handled server-side.
 *
 * @param {Object} params
 * @param {string} params.code - The authorization code
 * @param {string} params.redirect_uri - The redirect uri
 * @returns {Promise<Object>} Promise resolving to the token response
 */
const getToken = async function ({ code, redirect_uri }) {
  
  const requestBody = {
    code,
    redirect_uri,
    code_verifier: localStorage.getItem(CODE_VERIFIER),
  }
  return axios
    .post( API.USER.getToken,
      requestBody, 
      {
        headers: {
          'Content-Type': 'application/json',
        }
      }
    )
    .then((res) => {
        return res?.data;
    })
    .catch((error) => {
      console.error('Error fetching token:', error);
      throw error;
    });
}

export default getToken;
